import React from 'react'
import { Dropdown } from 'semantic-ui-react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

import { selectSection } from '../../actions/geoSections'


const sectionToOption = section => ({ key: section.id, value: section.id, text: section.name })

class SectionDropdown extends React.Component {
  render() {
    const { geoSections, selectedSectionId, selectSection } = this.props
    const sectionDropdownOptions = Object.values(geoSections).map(sectionToOption)
    sectionDropdownOptions.unshift({ key: '__blank', text: 'Не выбран', value: '' })
    return <Dropdown
      fluid selection search scrolling
      options={sectionDropdownOptions}
      value={selectedSectionId}
      onChange={selectSection}
    />
  }
}

function mapStateToProps(state) {
  return {
    ...state.dashboard,
    geoCategories: state.geoCategories,
    geoSections: state.geoSections,
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ selectSection }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SectionDropdown))
